import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import { MORE_THAN_ZERO_MESSAGE } from '../../constants'

export const OpenDeckSchemaObject = {
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.chains]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.tarp]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.coil_rack]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.ratchet_straps]: yup.boolean().default(false).notRequired(),
  /**
   * @example 16
   */
  [IEquipmentAttributeTypes.straps]: yup.number().moreThan(0, MORE_THAN_ZERO_MESSAGE).notRequired(),
}

export const OpenDeckSchema = yup.object(OpenDeckSchemaObject)

export type TOpenDeckSchema = yup.InferType<typeof OpenDeckSchema>
